import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_instance17v8p6g2424o4 as Companion_instance,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator1qrulkrel7e5m as Generator,
} from './FormRenderer.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance17fcxlkqs50ig as Companion_getInstance } from './helpers.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ToStringRenderer$view$lambda($this$ViewRenderer, _unused_var__etf5q3, readable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.gbb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = toString($this$reactiveScope.daj(readable));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ToStringRendererClass;
function ToStringRenderer() {
  if (ToStringRendererClass === VOID) {
    class $ {
      pdu(module_0, selector) {
        var tmp = Companion_instance;
        return tmp.qdu(module_0, this, selector, VOID, VOID, ToStringRenderer$view$lambda);
      }
      i20() {
        return 'As Text';
      }
      kdu(module_0, selector) {
        return Companion_getInstance().ldu_1;
      }
      edu() {
        return 0.02;
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).h94 = get_type;
    protoOf($).rdu = get_nullable;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).tdu = priority;
    protoOf($).fdu = matches;
    initMetadataForObject($, 'ToStringRenderer', VOID, VOID, [Generator()]);
    ToStringRendererClass = $;
  }
  return ToStringRendererClass;
}
var ToStringRenderer_instance;
function ToStringRenderer_getInstance() {
  return ToStringRenderer_instance;
}
//region block: init
ToStringRenderer_instance = new (ToStringRenderer())();
//endregion
//region block: exports
export {
  ToStringRenderer_instance as ToStringRenderer_instancei1qkyx3isyzf,
};
//endregion

//# sourceMappingURL=ToStringRenderer.mjs.map
